// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../../../../types';

import gql from 'graphql-tag';
export type BookingEnquiryDetailsEventFragment = { __typename?: 'Event', budget: number, attendees: number, location: string, currency: string, cateringNeeds?: string | null, additionalNotes?: string | null, spaceFacilities?: Array<{ __typename?: 'SpaceFacility', id: number, name: string }> | null };

export const BookingEnquiryDetailsEventFragmentDoc = gql`
    fragment BookingEnquiryDetailsEvent on Event {
  budget
  attendees
  location
  currency
  cateringNeeds
  additionalNotes
  spaceFacilities {
    id
    name
  }
}
    `;